export const IMPERSONATION_CONSTS = {
  // Storage keys (use sessionStorage for impersonation)
  token: 'impersonation_jwt',
  state: 'impersonation_state',
  originalAdmin: 'impersonation_original_admin',
  originalAdminContext: 'impersonation_original_admin_context',

  // Error codes
  ERROR_CODES: {
    TOKEN_EXPIRED: 'IMPERSONATION_TOKEN_EXPIRED',
    TOKEN_REVOKED: 'IMPERSONATION_TOKEN_REVOKED',
    TOKEN_INVALID: 'IMPERSONATION_TOKEN_INVALID',
    PERMISSION_DENIED: 'IMPERSONATION_PERMISSION_DENIED',
  },

  // UI messages
  MESSAGES: {
    START_SUCCESS: 'Impersonation started successfully',
    START_ERROR: 'Failed to start impersonation',
    STOP_SUCCESS: 'Impersonation ended successfully',
    STOP_ERROR: 'Failed to end impersonation',
    TOKEN_EXPIRED: 'The impersonation session has expired',
    TOKEN_REVOKED: 'The impersonation session has been revoked',
  },
};

export const IMPERSONATION_URLS = {
  START: '/impersonate/start',
  STOP: '/impersonate/stop',
  REVOKE: '/impersonate/revoke',
  ACTIVE: '/impersonate/active',
};

// Predefined reasons for impersonation
export const IMPERSONATION_REASONS = [
  { value: 'technical_support', label: 'Technical Support' },
  { value: 'incident_resolution', label: 'Incident Resolution' },
  { value: 'user_assistance', label: 'User Assistance' },
  { value: 'system_testing', label: 'System Testing' },
  { value: 'data_verification', label: 'Data Verification' },
  { value: 'training_demo', label: 'Training/Demo' },
  { value: 'configuration_support', label: 'System Configuration' },
  { value: 'other', label: 'Other' },
];
